

export const wanHero = {
    title: 'Wan 2.5：原生音訊 AI 影片生成器',
    sub: '聲音同步 • 唇形對齊 • 動態視覺 • 創作自由',
    desc:
      '阿里巴巴的 Wan 2.5 可生成含原生音訊的影片：對白、音樂與音效與畫面同步。支援文字或圖片生成 10 秒影片（720p/1080p），提供最大創作自由，無需後期配音。'
  };
